// src/config/environment.tsx

// Base IP for all API calls
type EnvSource =
  | ".env.local"
  | ".env.development"
  | ".env.production"
  | "unknown";

/**
 * Determine API base URL based on current env variables.
 */

export const getApiBaseUrl = (): string => {
  if (process.env.REACT_APP_ENV === "local") {
    return "http://127.0.0.1:5100";
  }
  if (
    process.env.REACT_APP_ENV === "development" ||
    process.env.NODE_ENV === "development"
  ) {
    // API URL
    return "https://salescrm-dev-api.gocloudee.com";
    // return "https://salescrm-api.gocloudee.com";
  }
  if (
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENV === "production"
  ) {
    return "https://salescrm-api.gocloudee.com";
  }
  return "http://43.209.73.229"; // Default to local IP
};

/**
 * Determine UI base URL based on current env variables.
 */
export const getApiBaseUrlUI = (): string => {
  if (process.env.REACT_APP_ENV === "local") {
    return "http://localhost:5300";
  }
  if (
    process.env.REACT_APP_ENV === "development" ||
    process.env.NODE_ENV === "development"
  ) {
    return "https://salescrm-dev.gocloudee.com";
  }
  if (
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENV === "production"
  ) {
    return "https://salescrm.gocloudee.com";
  }
  return "http://localhost:5300"; // Default to local
};

/**
 * Determine API port based on current env variables.
 * Note: Port is only used for local environment now.
 */
export const getApiPort = (): string => {
  if (process.env.REACT_APP_ENV === "local") {
    return process.env.REACT_APP_BACKEND_APP_PORT || "5100";
  }
  // For production and development with new URLs, port is not needed
  return "";
};

/**
 * Determine WebSocket base URL based on current env variables.
 */
export const getWebSocketBaseUrl = (): string => {
  if (
    process.env.REACT_APP_ENV === "development" ||
    process.env.NODE_ENV === "development"
  ) {
    // Websocket URL
    return "https://salescrm-dev-notification.gocloudee.com";
    // return "https://salescrm-notification.gocloudee.com";
  }
  if (
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENV === "production"
  ) {
    return "https://salescrm-notification.gocloudee.com";
  }
  return "https://salescrm-dev-notification.gocloudee.com"; // Default to dev
};

/**
 * Determine Middleware base URL for Engati chat APIs based on current env variables.
 */
export const getMiddlewareBaseUrl = (): string => {
  if (process.env.REACT_APP_ENV === "local") {
    return "http://127.0.0.1:5200"; // Local middleware
  }
  if (
    process.env.REACT_APP_ENV === "development" ||
    process.env.NODE_ENV === "development"
  ) {
    // Middelware link
    return "https://salescrm-dev-middleware.gocloudee.com";
    // return "https://salescrm-middleware.gocloudee.com";
  }
  if (
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENV === "production"
  ) {
    return "https://salescrm-middleware.gocloudee.com";
  }
  return "https://salescrm-dev-middleware.gocloudee.com"; // Default to dev
};

// Compute the backend URL components
const apiBaseUrl = getApiBaseUrl();
const apiBaseUrlUI = getApiBaseUrlUI();
const backendPort = getApiPort();

// Determine which .env file was loaded
let envSource: EnvSource = "unknown";
if (process.env.NODE_ENV === "production") {
  envSource = ".env.production";
} else if (process.env.NODE_ENV === "development") {
  envSource = ".env.development";
} else if (process.env.REACT_APP_ENV === "local") {
  envSource = ".env.local";
}

// Construct and export the full API base URL
export const API_BASE_URL = backendPort
  ? `${apiBaseUrl}:${backendPort}`
  : apiBaseUrl;
export const API_BASE_URL_UI = apiBaseUrlUI;
export const WS_BASE_URL = getWebSocketBaseUrl();
export const MIDDLEWARE_BASE_URL = getMiddlewareBaseUrl();
export const DEFAULT_AVATAR =
  "https://cloudee-sales-crm-artifact.s3.ap-southeast-7.amazonaws.com/public-artifacts/user/male.png";

// Other paths
export const base_path = "/";
export const img_path = "/";

export const VAPID_PUBLIC_KEY =
  "BJanhgkeSdnvWV8cHHft-B0DZUw3IEM_3BaQ8vXCE2h1gVcna8uTlUq82XVboxKzKB3FTTLH98TPZJTSt4KNXI4";
